import React, { useEffect, useState, useRef } from 'react';
import { Modal, Select, Radio, Input, Spin, notification } from 'antd';
import Button from '../../Button';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getMerchantWallets, getMoreMerchantWallets } from '../../../redux/actions/merchantWallets';
import { truncate } from '../../../utils/truncateFunction';
import { CustomSelectOption } from './CustomSelectOption';
import repeatIcon from '../../../img/default-svg/repeat.svg';
import repeatIconInex from '../../../img/inex/repeat.svg';
import repeatIconInsta from '../../../img/instaXchange/repeat.svg';
import repeatIconCoinera from '../../../img/coinera/repeat.svg';
import dashedLine from '../../../img/default-svg/dashed-line.svg';
import uploadFile from '../../../img/cpay-svg/upload.svg';
import { identity } from '../../../utils/getIdentity';
import AvatarAddressBook from '../../AddressBook/AvatarAddressBook';

import { cryptoApi } from '../../../service/cryptopay-api';
import { getMerchantBalances } from '../../../redux/actions/merchantData';
import {
  getCurrenciesRate,
  makeWithdraw,
  withdrawResetTwoFa,
  withdrawalEstimateMaxReset,
  uploadNewAutosign,
  checkAutosignStatus,
} from '../../../redux/actions/withdraw';
import WithdrawTwoFaConfirm from '../../Withdraw/WithdrawForm/WithdrawTwoFaConfirm';
import debounce from 'lodash/debounce';

import { Timer } from '../../Timer/Timer';
import { addMinutes } from '../../../utils/addMinutes';

import './styles.scss';
import { LoadingOutlined } from '@ant-design/icons';
import { tokenTypeEnd, isEvmNodeType } from '../../../utils/tokenNodeTypes';
import UploadAutosignWrapper from '../../Withdraw/UploadAutosignWrapper';
import TokenIcon from '../../TokenIcon';

const repeatIcons = {
  cpay: repeatIcon,
  nfg: repeatIcon,
  finvaro: repeatIcon,
  clarnium: repeatIcon,
  inex: repeatIconInex,
  insta: repeatIconInsta,
  coinera: repeatIconCoinera,
};

const WithdrawModal = ({
  openWithdraw,
  handleCloseWithdraw,
  merchantId,
  networkFilter,
  merchantWallets,
  getMerchantWallets,
  currencyId,
  merchantBalances,
  makeWithdraw,
  withdrawResetTwoFa,
  withdrawalEstimateMaxReset,
  fetching,
  currencies,
  autosignStep,
  uploadNewAutosign,
  checkAutosignStatus,
  autosignStatus,
  getMoreMerchantWallets,
  page,
  pages,
  countItem,
  merchantWalletsSentTo,
  pageSentTo,
  pagesSentTo,
  countItemSentTo,
  merchantData,
  getMerchantBalances,
}) => {
  const { t } = useTranslation();

  const validUntil = addMinutes(1);

  const [selectedCurrencyId, setSelectedCurrencyId] = useState(currencyId || undefined);
  const [selectedCurrency, setSelectedCurrency] = useState(undefined);
  const [selectedWallet, setSelectedWallet] = useState(undefined);
  const [sentToWallet, setSentToWallet] = useState('');
  const [selectedSentToWallet, setSelectedSentToWallet] = useState(undefined);
  const [sendToLabelState, setSendToLabelState] = useState('externalWallet');
  const [sentAmountBalance, setSentAmountBalance] = useState('');
  const [comment, setComment] = useState('');
  const [getAmountUSD, setGetAmountUSD] = useState('0.00');
  const [withdrawalInfo, setWithdrawalInfo] = useState();
  const [showToRequired, setShowToRequired] = useState(false);
  const [showTwoFaModal, setShowTwoFaModal] = useState(false);
  const [fees, setFees] = useState(null);
  const [disableResend, setDisableResend] = useState(false);
  const [showWarningMsg, setShowWarningMsg] = useState(false);
  const [warningMsg, setWarningMsg] = useState('');
  const [showWarningMaxMsg, setShowWarningMaxMsg] = useState(false);
  const [warningMaxMsg, setWarningMaxMsg] = useState('');
  const [showWarningRecipient, setShowWarningRecipient] = useState(false);
  const [warningRecipient, setWarningRecipient] = useState('');
  const [showWarningAddress, setShowWarningAddress] = useState(false);
  const [warningAddress, setWarningAddress] = useState('');
  const [decimalsLimit, setDecimalsLimit] = useState(0);
  const [showDecimalsWarning, setShowDecimalsWarning] = useState(false);
  const [isSelectedWallet, setIsSelectedWallet] = useState(undefined);
  const [destinationWallet, setDestinationWallet] = useState(undefined);
  const [fetchingMaxAmount, setFetchingMaxAmount] = useState(false);
  const [priority, setPriority] = useState('low');
  const [loadingFees, setLoadingFees] = useState(false);
  const [isOpenAutosignModal, setIsOpenAutosignModal] = useState(false);
  const [isShowAutosignModal, setIsShowAutosignModal] = useState(true);
  const [password, setPassword] = useState('');
  const [sign, setSign] = useState('');
  const ratesFetchTimer = useRef();
  const [addressBook, setAddressBook] = useState([]);
  const [selectedAddressBook, setSelectedAddressBook] = useState(undefined);
  const [addressBookPage, setAddressBookPage] = useState(1);
  const [addressBookPages, setAddressBookPages] = useState(1);
  const [walletVersionTick, setWalletVersionTick] = useState(0);
  const walletVersion = localStorage.getItem('walletVersion');
  const normalizeBalance = balance => {
    if (!balance) return { value: 0, usd: 0 };
    if (typeof balance === 'object') {
      return {
        value: balance.value ?? 0,
        usd: balance.usd ?? 0,
      };
    }
    return { value: balance, usd: 0 };
  };
  const getWalletAssets = wallet =>
    wallet?.tokens?.length > 0
      ? wallet.tokens
      : (wallet?.balances || []).map(asset => ({
          balance: asset?.balance,
          currency: asset?.currency?.name,
          currencyId: asset?.currency?.id,
          holdBalance: asset?.holdBalance,
          nodeType: asset?.currency?.nodeType,
          currencyType: asset?.currency?.currencyType,
        }));
  const getPrimaryWalletAsset = wallet => getWalletAssets(wallet)?.[0];
  const getWalletAssetByCurrencyId = (wallet, currencyId) =>
    getWalletAssets(wallet)?.find(asset => asset?.currencyId === currencyId);
  const getWalletNativeAsset = (wallet, nodeType) =>
    getWalletAssets(wallet)?.find(asset => asset?.currencyType === 'currency' && asset?.nodeType === nodeType);

  const effectiveNodeType = getPrimaryWalletAsset(isSelectedWallet)?.nodeType || isSelectedWallet?.nodeType;
  const isEstimatePriority = effectiveNodeType === 'btc';

  useEffect(() => {
    const bump = () => setWalletVersionTick(n => n + 1);
    const onStorage = e => {
      if (e.key === 'walletVersion') bump();
    };
    window.addEventListener('walletVersionChange', bump);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('walletVersionChange', bump);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  const wallets = selectedCurrency && merchantWallets.filter(w => w.currencyId === selectedCurrencyId);

  const walletsWithTokens = selectedCurrency && merchantWallets?.filter(w => getWalletAssets(w).length > 0);

  //
  const walletsSentTo = selectedCurrency && merchantWalletsSentTo.filter(w => w.currencyId === selectedCurrencyId);

  const walletsWithTokensSentTo = selectedCurrency && merchantWalletsSentTo?.filter(w => getWalletAssets(w).length > 0);

  useEffect(() => () => ratesFetchTimer.current && clearTimeout(ratesFetchTimer.current), []);

  useEffect(() => {
    if (sendToLabelState === 'addressBook') {
      const walletAddressBook = addressBook?.filter(item => item?._id === selectedAddressBook);
      setDestinationWallet(walletAddressBook[0]?.wallets[0]?.address);
    } else if (sentToWallet || selectedSentToWallet) {
      const walletToSend = sendToLabelState === 'externalWallet' ? sentToWallet : selectedSentToWallet;
      setDestinationWallet(walletToSend);
    }
  }, [sendToLabelState, sentToWallet, selectedSentToWallet, selectedAddressBook]);

  const getAddressBook = async (page = 1) => {
    const response = await cryptoApi.getAddressBookList({
      typeNetwork: networkFilter,
      nodeType: isSelectedWallet?.nodeType,
      page,
    });
    setAddressBook([...addressBook, ...response?.data?.entities]);
    setAddressBookPages(response?.data?.pages);
    setAddressBookPage(response?.data?.page);
  };

  useEffect(() => {
    if (isSelectedWallet) {
      getAddressBook();
    }
  }, [networkFilter, isSelectedWallet]);

  useEffect(() => {
    if (merchantId && selectedCurrencyId) {
      getMerchantWallets(merchantId, {
        typeNetwork: networkFilter,
        limit: 5,
        page: 1,
        currencyIds: selectedCurrencyId,
        typeWallet: 'merchant',
        positiveBalance: false,
        isSentTo: true,
        walletVersion,
      });
    }
  }, [sendToLabelState, selectedCurrencyId, walletVersion, walletVersionTick]);

  const walletsWithTokensOrder =
    selectedCurrency &&
    walletsWithTokens.map(w => {
      const selectedAsset = getWalletAssetByCurrencyId(w, selectedCurrencyId) || getPrimaryWalletAsset(w);
      return {
        ...w,
        balance: normalizeBalance(selectedAsset?.balance),
        currency: selectedAsset?.currency,
        currencyId: selectedAsset?.currencyId,
        holdBalance: selectedAsset?.holdBalance ?? undefined,
        nodeType: selectedAsset?.nodeType || w?.nodeType,
        currencyType: selectedAsset?.currencyType || w?.currencyType,
      };
    });

  const walletsWithTokensOrderSentTo =
    selectedCurrency &&
    walletsWithTokensSentTo.map(w => {
      const selectedAsset = getWalletAssetByCurrencyId(w, selectedCurrencyId) || getPrimaryWalletAsset(w);
      return {
        ...w,
        balance: normalizeBalance(selectedAsset?.balance),
        currency: selectedAsset?.currency,
        currencyId: selectedAsset?.currencyId,
        holdBalance: selectedAsset?.holdBalance ?? undefined,
        nodeType: selectedAsset?.nodeType || w?.nodeType,
        currencyType: selectedAsset?.currencyType || w?.currencyType,
      };
    });

  const walletsByCurrency = selectedCurrency && [...wallets, ...walletsWithTokensOrder];
  const walletsByCurrencySentTo = selectedCurrency && [...walletsSentTo, ...walletsWithTokensOrderSentTo];

  const availableToWallets = selectedWallet && walletsByCurrencySentTo.filter(w => w._id !== selectedWallet);

  const handleDisableResend = () => {
    const timeout = setTimeout(() => {
      setDisableResend(false);
    }, 60000);

    return () => clearTimeout(timeout);
  };

  useEffect(() => {
    if (merchantId) {
      if (selectedCurrencyId) {
        getMerchantWallets(merchantId, {
          typeNetwork: networkFilter,
          limit: 5,
          page: 1,
          currencyIds: selectedCurrencyId,
          typeWallet: 'merchant',
          isWithdrawal: true,
          positiveBalance: true,
          walletVersion,
        });
      }
    }
  }, [merchantId, networkFilter, selectedCurrencyId, walletVersion, walletVersionTick]);

  useEffect(() => {
    if (currencyId) {
      setSelectedCurrencyId(currencyId);
      setSelectedCurrency(merchantBalances.find(merchantBalance => merchantBalance.currency.id === selectedCurrencyId));
    }
  }, [currencyId]);

  useEffect(() => {
    setSelectedCurrency(merchantBalances.find(merchantBalance => merchantBalance.currency.id === selectedCurrencyId));
  }, [selectedCurrencyId]);

  useEffect(() => {
    if (selectedWallet) {
      setSelectedWallet(selectedWallet);
    }
  }, [selectedWallet]);

  useEffect(() => {
    if (sentToWallet && selectedWallet && selectedCurrency) {
      const findSentToWallet = availableToWallets.find(w => w.address === sentToWallet);
      setSelectedSentToWallet(findSentToWallet?._id);
    }
  }, [sentToWallet, selectedWallet, selectedCurrency]);

  const closeWithdrawModal = () => {
    handleCloseWithdraw();
  };

  useEffect(() => {
    if (sentToWallet || selectedSentToWallet) {
      setShowToRequired(false);
    }
  }, [sentToWallet, selectedSentToWallet]);

  useEffect(() => {
    if (selectedWallet) {
      const currentWallet = selectedWallet && walletsByCurrency?.find(wallet => wallet._id === selectedWallet);
      setIsSelectedWallet(currentWallet);
    }
  }, [selectedWallet]);

  useEffect(() => {
    if (isSelectedWallet) {
      const currentCurrency = currencies.find(currency => isSelectedWallet.currencyId === currency._id);
      setDecimalsLimit(currentCurrency ? currentCurrency.decimals : 18);
    } else {
      const currentCurrency = currencies.find(currency => selectedCurrency?.currency?.id === currency._id);
      setDecimalsLimit(currentCurrency ? currentCurrency.decimals : 18);
    }

    return () => withdrawalEstimateMaxReset();
  }, [isSelectedWallet, selectedCurrency]);

  useEffect(() => {
    if (isSelectedWallet) {
      checkAutosignStatus(merchantId, isSelectedWallet._id);
    }
  }, [merchantId, isSelectedWallet]);

  useEffect(() => {
    setIsShowAutosignModal(autosignStatus);
  }, [autosignStatus]);

  const getWithdrawalInfo = async (merchantId, walletId) => {
    try {
      const response = await cryptoApi.getWithdrawalInfo(merchantId, walletId);
      const data = await response.data;
      setWithdrawalInfo(data);
    } catch (error) {
      console.log('error');
    }
  };

  const setFetchTimer = (action, value) => {
    ratesFetchTimer.current && clearTimeout(ratesFetchTimer.current);
    ratesFetchTimer.current = setTimeout(() => action(value), 500);
  };

  useEffect(() => {
    if (sentAmountBalance) {
      setFetchTimer(convertTokensToUsd, sentAmountBalance);
    } else {
      setGetAmountUSD('');
    }
  }, [sentAmountBalance, showDecimalsWarning]);

  useEffect(() => {
    if (sentAmountBalance && destinationWallet) {
      estimateFee(sentAmountBalance || 0);
    }
  }, [priority, sentAmountBalance, destinationWallet, isSelectedWallet]);

  const debouncedEstimateFee = useRef(
    debounce(async (...params) => {
      try {
        const response = await cryptoApi.getFeeEstimate(...params);
        const data = response?.data;
        if (data) {
          setFees(data);
          setShowWarningMsg(false);
          setShowWarningAddress(false);
          setShowWarningRecipient(false);
          setWarningMsg('');
          setWarningAddress('');
          setWarningRecipient('');
          setShowWarningMaxMsg(false);
          setWarningMaxMsg('');
        }

        setLoadingFees(false);
      } catch (error) {
        const errMsg = error?.data?.message;
        notification.error({
          message: errMsg,
        });
        if (errMsg?.includes('have enough')) {
          setShowWarningMsg(true);
          setWarningMsg(errMsg);
          setShowWarningAddress(false);
          setWarningAddress('');
          setFees(null);
        }
        if (errMsg?.includes('recipient balance needs')) {
          setShowWarningMsg(false);
          setWarningMsg('');
          setShowWarningAddress(false);
          setWarningAddress('');
          setShowWarningRecipient(true);
          setWarningRecipient(errMsg);
          setFees(null);
        }
        if (errMsg === 'Address INVALID') {
          setFees(null);
          setShowWarningAddress(true);
          setShowWarningMsg(false);
          setWarningMsg('');
          setWarningAddress('Address is invalid');
        }
        setShowWarningMaxMsg(false);
        setWarningMaxMsg('');

        setLoadingFees(false);
      }
    }, 3000)
  );

  useEffect(() => {
    if (sign && sentAmountBalance && destinationWallet) {
      estimateFee(sentAmountBalance);
    }
  }, [sign]);

  const estimateFee = value => {
    setLoadingFees(true);
    if (isSelectedWallet && value) {
      debouncedEstimateFee.current(
        merchantId,
        isSelectedWallet?._id,
        destinationWallet,
        `${value}`,
        isSelectedWallet?.hasOwnProperty('holdBalance') ? isSelectedWallet?.currencyId : undefined,
        isSelectedWallet?.hasOwnProperty('holdBalance') ? isSelectedWallet?.currencyId : undefined,
        isEstimatePriority ? priority : undefined,
        password ? password : undefined,
        sign ? sign : undefined
      );
    } else {
      setLoadingFees(false);
    }
  };

  const convertTokensToUsd = async value => {
    const rates = await getCurrenciesRate();

    if (rates && rates.data && isSelectedWallet) {
      const amountInUsd = value * +rates.data[isSelectedWallet?.currency];
      setGetAmountUSD(amountInUsd);
    }
    if (rates && rates.data && selectedCurrency) {
      const amountInUsd = value * +rates.data[selectedCurrency?.currency?.name];
      setGetAmountUSD(amountInUsd);
    }
  };

  const convertUsdToTokens = async value => {
    if (+value) {
      setGetAmountUSD(value);

      const rates = await getCurrenciesRate();

      if (rates && rates.data && isSelectedWallet) {
        const getCurrencyAmount = (value / +rates.data[isSelectedWallet?.currency]).toFixed(decimalsLimit) || 0;
        setSentAmountBalance(getCurrencyAmount);
        setShowDecimalsWarning(false);
        estimateFee(getCurrencyAmount);
      }
    } else {
      setSentAmountBalance('');
      setGetAmountUSD('');
    }
  };

  const handleEstimateMax = async () => {
    setFetchingMaxAmount(true);

    const walletCurrencyId = isSelectedWallet?.currencyId || isSelectedWallet?.balances?.[0]?.currency?.id;
    const data = {
      to: destinationWallet,
      currencyToken: walletCurrencyId || undefined,
      destinationToken: walletCurrencyId || undefined,
      priority: isEstimatePriority ? priority : undefined,
      password: password || undefined,
      sign: sign || undefined,
    };

    if (!destinationWallet) {
      setShowToRequired(true);
    }

    if (merchantId && isSelectedWallet && (sentToWallet || selectedSentToWallet || selectedAddressBook)) {
      try {
        const response = await cryptoApi.withdrawalEstimateMax(merchantId, isSelectedWallet._id, data);
        const dataAmount = await response.data;
        if (dataAmount) {
          setSentAmountBalance(dataAmount?.amount);
          setShowDecimalsWarning(false);
          await convertTokensToUsd(dataAmount?.amount);

          setShowWarningMaxMsg(false);
          setWarningMaxMsg('');
        }
      } catch (error) {
        const errMsg = error?.data?.message;

        if (errMsg) {
          setShowWarningMaxMsg(true);
          setWarningMaxMsg(errMsg);
          setShowWarningMsg(false);
          setWarningMsg('');
          setShowWarningAddress(false);
          setWarningAddress('');
        }
      }
    }

    setFetchingMaxAmount(false);
  };

  const sendWithdraw = () => {
    setDisableResend(true);

    handleDisableResend();
    if (isSelectedWallet && destinationWallet && (sentToWallet || selectedSentToWallet || selectedAddressBook)) {
      makeWithdraw(
        isSelectedWallet?._id,
        destinationWallet,
        `${sentAmountBalance}`,
        merchantId,
        isSelectedWallet?.hasOwnProperty('holdBalance') ? isSelectedWallet?.currencyId : undefined,
        isEstimatePriority ? priority : undefined,
        comment,
        password || undefined,
        sign || undefined,
        identity === 'inex' ? selectedCurrency?.currency?.name : undefined,
        isEvmNodeType(effectiveNodeType)
      ).then(response => {
        if (response && response.data) {
          if (response.data.twoFactorToken || response.data.emailSent || response.data.codeSent) {
            setShowTwoFaModal(true);
          } else {
            console.log(
              'getMerchantBalances called from WithdrawModal.jsx after withdrawal submit, merchantId:',
              merchantId,
              'networkFilter:',
              networkFilter,
              'walletVersion:',
              walletVersion
            );
            getMerchantBalances(merchantId, networkFilter, true, false, walletVersion);
          }
        }
      });
    }
  };

  const clearWithdrawState = () => {
    console.log(
      'getMerchantBalances called from WithdrawModal.jsx clearWithdrawState, merchantId:',
      merchantId,
      'networkFilter:',
      networkFilter,
      'walletVersion:',
      walletVersion
    );
    getMerchantBalances(merchantId, networkFilter, true, false, walletVersion);
    closeWithdrawModal();
  };

  const uploadAutosign = data => {
    const { password, sign } = data;
    setPassword(password || undefined);
    setSign(sign || undefined);

    setIsOpenAutosignModal(false);
  };

  const disabledRequest =
    !selectedCurrency ||
    !selectedWallet ||
    !sentAmountBalance ||
    !destinationWallet ||
    showWarningMsg ||
    showWarningAddress ||
    showWarningRecipient ||
    showWarningMaxMsg;

  const selectedCurrencyValue = selectedCurrency && (
    <CustomSelectOption
      name={selectedCurrency.currency.name}
      title={selectedCurrency.currency.title}
      balanceValue={selectedCurrency.balance.value}
      balanceUsd={selectedCurrency.balance.usd}
      identity="currency"
    />
  );

  const selectedWalletObj = selectedCurrency && merchantWallets?.find(item => item._id === selectedWallet);
  const selectedWalletNativeAsset =
    selectedCurrency && selectedWalletObj
      ? getWalletNativeAsset(selectedWalletObj, selectedCurrency.currency.nodeType)
      : null;
  const fullInfoAboutSelectedCurrency = selectedWalletNativeAsset
    ? {
        balance: selectedWalletNativeAsset.balance,
        currency: selectedWalletNativeAsset.currency,
        currencyType: selectedWalletNativeAsset.currencyType,
        nodeType: selectedWalletNativeAsset.nodeType,
      }
    : (() => {
        const nodeType = selectedCurrency?.currency?.nodeType;
        const nativeWallet =
          nodeType && merchantWallets?.find(w => w.currencyType === 'currency' && w.nodeType === nodeType);
        return selectedWalletObj || nativeWallet;
      })();
  const selectedTokenTypeEnd =
    (fullInfoAboutSelectedCurrency &&
      tokenTypeEnd(
        fullInfoAboutSelectedCurrency.currencyType,
        fullInfoAboutSelectedCurrency.nodeType,
        fullInfoAboutSelectedCurrency.currency
      )) ||
    '';

  return (
    <>
      <WithdrawTwoFaConfirm
        isFromHome={true}
        isVisible={showTwoFaModal}
        setIsVisible={setShowTwoFaModal}
        action={makeWithdraw}
        fetching={fetching}
        clearWithdrawState={clearWithdrawState}
        body={[
          isSelectedWallet?._id,
          destinationWallet,
          `${sentAmountBalance}`,
          merchantId,
          isSelectedWallet?.hasOwnProperty('holdBalance') ? isSelectedWallet?.currencyId : undefined,
          isEstimatePriority ? priority : undefined,
          comment,
          password || undefined,
          sign || undefined,
          identity === 'inex' ? selectedCurrency?.currency?.name : undefined,
          isEvmNodeType(effectiveNodeType),
        ]}
        withdrawResetTwoFa={withdrawResetTwoFa}
      />
      <Modal
        className={`withdraw__modal withdraw__modal-${identity}`}
        title={t('withdraw.withdraw')}
        width={560}
        visible={openWithdraw}
        footer={null}
        onCancel={closeWithdrawModal}
      >
        <div className="withdraw__modal-container">
          <div className="withdraw__modal-container__currency">
            <span>{t('currency')}</span>
            <Select
              value={selectedCurrency ? selectedCurrencyValue : t('wallets.chooseCurrency')}
              onChange={value => {
                setSelectedCurrencyId(value);
                setSelectedWallet(undefined);
                setSentAmountBalance('');
                setGetAmountUSD('0.00');
                setSendToLabelState('externalWallet');
                setSentToWallet(undefined);
                setSelectedSentToWallet(undefined);
                setSelectedAddressBook(undefined);
                setIsSelectedWallet(undefined);
                setShowDecimalsWarning(false);
                setDestinationWallet(undefined);
                setShowWarningAddress(false);
                setShowWarningRecipient(false);
                setShowWarningMsg('');
                setWarningMsg('');
                setShowWarningMaxMsg(false);
                setWarningMaxMsg('');
                setWarningAddress('');
                setWarningRecipient('');
                setSign('');
                setPassword('');

                setFees(null);
              }}
              showSearch
              className={`withdraw__modal-container__selected-${selectedCurrency ? 'active' : 'initial'} custom-select custom-select-${identity}`}
              filterOption={(input, option) => (option?.title ?? '').toLowerCase().includes(input.toLowerCase())}
            >
              {merchantBalances?.map(currency =>
                currency.balance.usd !== 0 ? (
                  <Select.Option
                    key={currency.currency.id}
                    title={currency.currency.title}
                    value={currency.currency.id}
                  >
                    <CustomSelectOption
                      name={currency.currency.name}
                      title={currency.currency.title}
                      balanceValue={currency.balance.value}
                      balanceUsd={currency.balance.usd}
                      identity="currency"
                    />
                  </Select.Option>
                ) : null
              )}
            </Select>
            {selectedCurrency && selectedCurrency.balance.value == 0 && (
              <span
                className={`withdraw__modal-container__currency-zero withdraw__modal-container__currency-zero-${identity}`}
              >
                {t('admin.choose_another')}
              </span>
            )}
          </div>
          <div className="replenish__modal-container__address">
            <span>{t('wallets.walletAddress')}</span>
            <Select
              disabled={!selectedCurrency || selectedCurrency.balance.value == 0}
              value={selectedWallet ?? t('multisendWithdraw.chooseWalletAddress')}
              onChange={value => {
                setSelectedWallet(value);
                getWithdrawalInfo(merchantId, value);
                setShowDecimalsWarning(false);
                setShowWarningAddress(false);
                setShowWarningMsg('');
                setWarningMsg('');
                setWarningAddress('');
                setShowWarningMaxMsg(false);
                setSign('');
                setPassword('');
                setWarningMaxMsg('');
                setFees(null);
              }}
              className={`withdraw__modal-container__selected-${selectedWallet ? 'active' : 'initial'}`}
            >
              {selectedCurrency &&
                walletsByCurrency.length > 0 &&
                walletsByCurrency
                  ?.filter(w => w?.address !== selectedSentToWallet)
                  ?.map(wallet => {
                    return (
                      <Select.Option className="withdraw__modal-container__select" value={wallet._id} key={wallet._id}>
                        <CustomSelectOption
                          name={wallet.currency}
                          title={truncate(wallet.address, 14)}
                          balanceValue={wallet.balance.value}
                          balanceUsd={wallet.balance.usd}
                          identity="wallet"
                          currencyType={wallet.currencyType}
                          nodeType={wallet.nodeType}
                        />
                      </Select.Option>
                    );
                  })}
              {page < pages && (
                <Select.Option>
                  <Button
                    className={`withdraw__modal-container__load-more withdraw__modal-container__load-more-${identity}`}
                    onClick={e => {
                      e.stopPropagation();
                      getMoreMerchantWallets(merchantId, {
                        typeNetwork: networkFilter,
                        limit: 5,
                        currencyIds: selectedCurrencyId,
                        typeWallet: 'merchant',
                        page: +page + 1,
                        isWithdrawal: true,
                        positiveBalance: true,
                        isLoadMoreTogether: true,
                        walletVersion,
                      });
                    }}
                  >
                    Load more
                  </Button>{' '}
                </Select.Option>
              )}
            </Select>

            {selectedWallet && selectedCurrency?.currency?.type === 'token' && (
              <div className="replenish__modal-container__token">
                {fullInfoAboutSelectedCurrency?.currency} {selectedTokenTypeEnd}:{' '}
                {`${fullInfoAboutSelectedCurrency?.balance?.value} ${fullInfoAboutSelectedCurrency?.currency} ${selectedTokenTypeEnd} - $${fullInfoAboutSelectedCurrency?.balance?.usd}`}
              </div>
            )}
          </div>

          <div className="withdraw__modal-container__sent-address">
            <div className="withdraw__modal-container__sent-address-sentTo">
              <span>Sent to</span>
              <Radio.Group
                disabled={!selectedCurrency || !selectedWallet || selectedCurrency.balance.value == 0}
                value={sendToLabelState}
                onChange={e => {
                  setSendToLabelState(e.target.value);
                  setSentToWallet(undefined);
                  setSelectedSentToWallet(undefined);
                  setShowWarningAddress(false);
                  setSelectedAddressBook(undefined);
                  setDestinationWallet(undefined);
                }}
              >
                <Radio value="externalWallet">{t('withdraw.externalWallet')}</Radio>
                <Radio value="internalWallet" disabled={availableToWallets?.length === 0}>
                  {t('withdraw.internalWallet')}
                </Radio>
                <Radio value="addressBook" disabled={addressBook?.length === 0}>
                  {t('withdraw.addressBook')}
                </Radio>
              </Radio.Group>
            </div>
            {sendToLabelState === 'externalWallet' && (
              <Input
                onChange={e => {
                  setSelectedSentToWallet(undefined);
                  setSelectedAddressBook(undefined);
                  setSentToWallet(e.target.value);
                }}
                value={sentToWallet}
                className="withdraw__modal-container__input"
                placeholder={t('wallets.walletAddress')}
              />
            )}
            {sendToLabelState === 'addressBook' && (
              <Select
                onChange={value => {
                  setSentToWallet(undefined);
                  setSelectedAddressBook(value);
                  setShowWarningAddress(false);
                }}
                disabled={
                  !selectedCurrency ||
                  !selectedWallet ||
                  selectedCurrency.balance.value == 0 ||
                  addressBook?.length === 0
                }
                value={selectedAddressBook ?? t('multisendWithdraw.chooseWalletAddress')}
                className={`withdraw__modal-container__selected-${selectedSentToWallet ? 'active' : 'initial'}`} //
              >
                {selectedCurrency &&
                  selectedWallet &&
                  addressBook?.length > 0 &&
                  addressBook?.map((address, index) => {
                    return (
                      <Select.Option
                        className="withdraw__modal-container__select"
                        value={address?._id}
                        key={address._id}
                      >
                        <div className="address-book">
                          <AvatarAddressBook name={address?.name} index={index + 1} width="20px" height="20px" />
                          <div>{address?.name}</div>
                          <div className="address-book__separation">-</div>
                          <TokenIcon tokenName={isSelectedWallet.currency} />
                          <span>{truncate(address?.wallets[0]?.address, 14, '..')}</span>
                        </div>
                      </Select.Option>
                    );
                  })}
                {addressBookPage < addressBookPages && (
                  <Select.Option>
                    <Button
                      className={`withdraw__modal-container__load-more withdraw__modal-container__load-more-${identity}`}
                      onClick={e => {
                        e.stopPropagation();
                        getAddressBook(addressBookPage + 1);
                      }}
                    >
                      Load more
                    </Button>{' '}
                  </Select.Option>
                )}
              </Select>
            )}
            {sendToLabelState === 'internalWallet' && (
              <Select
                onChange={value => {
                  setSentToWallet(undefined);
                  setSelectedSentToWallet(value);
                  setSelectedAddressBook('');
                  setShowWarningAddress(false);
                }}
                disabled={
                  !selectedCurrency ||
                  !selectedWallet ||
                  selectedCurrency.balance.value == 0 ||
                  availableToWallets?.length === 0
                }
                value={selectedSentToWallet ?? t('multisendWithdraw.chooseWalletAddress')}
                className={`withdraw__modal-container__selected-${selectedSentToWallet ? 'active' : 'initial'}`} //
              >
                {selectedCurrency &&
                  selectedWallet &&
                  availableToWallets?.length > 0 &&
                  availableToWallets?.map(wallet => {
                    return (
                      <Select.Option
                        className="withdraw__modal-container__select"
                        value={wallet.address}
                        key={wallet._id}
                      >
                        <CustomSelectOption
                          name={wallet.currency}
                          title={truncate(wallet.address, 14)}
                          balanceValue={wallet.balance.value}
                          balanceUsd={wallet.balance.usd}
                          identity="walletTo"
                          currencyType={wallet.currencyType}
                          nodeType={wallet.nodeType}
                        />
                      </Select.Option>
                    );
                  })}
                {pageSentTo < pagesSentTo && (
                  <Select.Option>
                    <Button
                      className={`withdraw__modal-container__load-more withdraw__modal-container__load-more-${identity}`}
                      onClick={e => {
                        e.stopPropagation();
                        getMoreMerchantWallets(merchantId, {
                          typeNetwork: networkFilter,
                          limit: 5,
                          currencyIds: selectedCurrencyId,
                          typeWallet: 'merchant',
                          page: +pageSentTo + 1,
                          positiveBalance: false,
                          isSentTo: true,
                          isLoadMoreTogether: true,
                          walletVersion,
                        });
                      }}
                    >
                      Load more
                    </Button>{' '}
                  </Select.Option>
                )}
              </Select>
            )}
            {showToRequired && (
              <span
                className={`withdraw__modal-container__currency-zero withdraw__modal-container__currency-zero-${identity}`}
              >
                {t('admin.fill_in')}
              </span>
            )}
            {showWarningAddress && (
              <span
                className={`withdraw__modal-container__currency-zero withdraw__modal-container__currency-zero-${identity}`}
              >
                {warningAddress}
              </span>
            )}
            {isSelectedWallet && !isShowAutosignModal && (
              <div
                className={`withdraw__modal-container__autosign withdraw__modal-container__autosign-${identity}`}
                onClick={() => setIsOpenAutosignModal(true)}
              >
                <img src={uploadFile} alt="upload" />
                <span>{!sign ? t('withdraw.uploadAutosign') : `${sign?.slice(0, 15)}...`}</span>
              </div>
            )}
          </div>

          {selectedCurrency?.currency?.nodeType === 'ton' && (
            <div className="withdraw__modal-container__amount">
              <span>{identity === 'clarnium' ? 'Memo' : 'Comment'}</span>
              <Input
                className="withdraw__modal-container__input"
                value={comment}
                onChange={e => setComment(e.target.value)}
              />
            </div>
          )}

          <div className="withdraw__modal-container__amount">
            <div className="withdraw__modal-container__amount-balance">
              <span>{t('amount')}</span>
              {withdrawalInfo?.minimumWithdrawalUsd && (
                <span className="withdraw__modal-container__amount-minimum">
                  Minimum ${withdrawalInfo?.minimumWithdrawalUsd}
                </span>
              )}
            </div>
            <Input
              value={sentAmountBalance}
              onChange={e => {
                if (e.target.value < 0) {
                  setSentAmountBalance(0);
                  return;
                }
                if (
                  !e.target.value.toString().split('.')[1] ||
                  e.target.value.toString().split('.')[1].length <= decimalsLimit
                ) {
                  setSentAmountBalance(e.target.value);
                  setFetchTimer(convertTokensToUsd, e.target.value);
                  setShowDecimalsWarning(false);
                } else {
                  setShowDecimalsWarning(true);
                  setSentAmountBalance(sentAmountBalance);
                  setFetchTimer(convertTokensToUsd, sentAmountBalance);
                }
              }}
              className="withdraw__modal-container__input"
              type="number"
              suffix={
                <p
                  className={`withdraw__modal-container__input-max withdraw__modal-container__input-max-${identity}`}
                  onClick={handleEstimateMax}
                >
                  {fetchingMaxAmount ? (
                    <Spin
                      indicator={
                        <LoadingOutlined
                          className={`spin-${identity}`}
                          style={{ fontSize: 18, color: '#CD081E' }}
                          spin
                        />
                      }
                    />
                  ) : (
                    <div style={{ color: identity !== 'finvaro' ? '#CD081E' : '#8097B2' }}>MAX</div>
                  )}
                </p>
              }
            />
            {showWarningMaxMsg && selectedWallet && (
              <span className="withdraw__modal-container__amount-warning">{warningMaxMsg}</span>
            )}
            {showDecimalsWarning && (
              <span className="withdraw__modal-container__amount-warning">
                The maximum decimal value for {isSelectedWallet?.currency} is {decimalsLimit}.
              </span>
            )}
            {showWarningMsg && selectedWallet && (
              <span className="withdraw__modal-container__amount-warning">{warningMsg}</span>
            )}
            {showWarningRecipient && selectedWallet && (
              <span className="withdraw__modal-container__amount-warning">{warningRecipient}</span>
            )}
            {isEstimatePriority && (
              <div
                className={`withdraw__modal-container__amount__transaction-speed withdraw__modal-container__amount__transaction-speed-${identity}`}
              >
                <Radio.Group
                  // disabled={validWallets?.length <= 1}
                  value={priority}
                  onChange={e => {
                    setPriority(e.target.value);
                    // estimateFee(sentAmountBalance || 0)
                  }}
                >
                  <Radio value="low">{t('withdraw.low')}</Radio>
                  <Radio value="medium">{t('withdraw.medium')}</Radio>
                  <Radio value="high">{t('withdraw.high')}</Radio>
                </Radio.Group>
              </div>
            )}
          </div>

          <div className="withdraw__modal-container__usd">
            <div className="withdraw__modal-container__usd-balance">
              <span>Exchange rate in USD:</span>
              <img src={repeatIcons[identity]} alt="exchange" />
            </div>
            <Input
              value={(+getAmountUSD).toFixed(2)}
              onChange={e => {
                setGetAmountUSD(e.target.value);
                setFetchTimer(convertUsdToTokens, e.target.value);
              }}
              className="withdraw__modal-container__input"
              type="number"
              prefix="$"
            />
          </div>

          {withdrawalInfo?.systemFeeWithdrawal ? (
            <div className="withdraw__modal-container__fee">
              <p className="withdraw__modal-container__fee-systemFeeWithdrawal">
                {t('wallets.payment', { systemFeeWithdrawal: withdrawalInfo?.systemFeeWithdrawal })}
              </p>
            </div>
          ) : null}

          {withdrawalInfo?.systemFeeWithdrawal === 0 ? (
            <div className="withdraw__modal-container__fee">
              <p className="withdraw__modal-container__fee-systemFeeWithdrawal">
                {t('wallets.payment', { systemFeeWithdrawal: withdrawalInfo.systemFeeWithdrawal })}
              </p>
            </div>
          ) : null}

          {sentAmountBalance && (
            <div className="withdraw__modal-container__total">
              <img src={dashedLine} alt="dashed" />
              <span className="withdraw__modal-container__total-total">{t('total')}</span>
              <span
                className={`withdraw__modal-container__total-info withdraw__modal-container__total-info-${identity}`}
              >
                {t('wallets.feeCalc')}:
              </span>
              <span className="withdraw__modal-container__total-calculate">
                {!loadingFees &&
                  `${sentAmountBalance} ${isSelectedWallet?.currency || selectedCurrency?.currency?.name || ''}${' '}`}
                {loadingFees ? (
                  <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 24 }} spin />} />
                ) : (
                  <span>
                    {fees
                      ? ` + ${fees.minerFee} ${fees.currencyMinerFee} + ${fees.systemFee} ${fees.currencyFee}`
                      : ''}{' '}
                  </span>
                )}
              </span>
            </div>
          )}

          <Button
            className="withdraw__modal-container__submit"
            onClick={sendWithdraw}
            loading={fetching}
            disabled={disableResend || disabledRequest}
          >
            {disableResend ? (
              <>
                {' '}
                {t('submit')} in <Timer validUntil={validUntil} onExpire={() => setDisableResend(false)} />{' '}
              </>
            ) : (
              t('submit')
            )}
          </Button>
        </div>
        <UploadAutosignWrapper
          step={autosignStep}
          uploadAutosign={uploadAutosign}
          onCancel={() => setIsOpenAutosignModal(false)}
          isOpen={isOpenAutosignModal}
        />
      </Modal>
    </>
  );
};

const mapStateToProps = state => ({
  merchantWallets: state.merchantWallets.data,
  page: state.merchantWallets.page,
  pages: state.merchantWallets.pages,
  countItem: state.merchantWallets.countItem,
  merchantWalletsSentTo: state.merchantWallets.dataSentTo,
  pageSentTo: state.merchantWallets.pageSentTo,
  pagesSentTo: state.merchantWallets.pagesSentTo,
  countItemSentTo: state.merchantWallets.countItemSentTo,
  fetching: state.withdraw.fetching,
  fetchingMaxAmount: state.withdraw.fetchingMaxAmount,
  maxAmount: state.withdraw.maxAmount,
  currencies: state.currencies.data,
  autosignStep: state.withdraw.autosignStep,
  autosignStatus: state.withdraw.autosignStatus,
  merchantData: state.merchantData.data,
});

const mapDispatchToProps = dispatch => ({
  getMerchantWallets: getMerchantWallets(dispatch),
  getMoreMerchantWallets: getMoreMerchantWallets(dispatch),
  makeWithdraw: makeWithdraw(dispatch),
  withdrawalEstimateMaxReset: () => dispatch(withdrawalEstimateMaxReset()),
  withdrawResetTwoFa: () => dispatch(withdrawResetTwoFa()),
  uploadNewAutosign: uploadNewAutosign(dispatch),
  checkAutosignStatus: checkAutosignStatus(dispatch),
  getMerchantBalances: getMerchantBalances(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WithdrawModal);
